/**
 * Filename: vue 扩展
 * Created Date:2021/9/6
 * Author: pyh
 *
 * Copyright (c) 2021 Your Company
 */

import Vue from 'vue';

// axios
import '@/services/index';

// 接口配置
import server from '@/services/serve';
Vue.prototype.server = server;

// 公共方法
import utils from '@/utils/index';
Vue.prototype.utils = utils;

// 静态资源文件
// import configJson from '@/configJson';
// Vue.prototype.configJson = configJson;

// 全局 mixin
// import mixin from '@/mixin/index';
// Vue.mixin(mixin);

// AUDIENCE
// Vue.prototype.AUDIENCE = process.env.VUE_APP_AUDIENCE;

// moment
// import moment from 'moment';
// Vue.prototype.moment = moment;

// video.js
import videoJS from 'video.js';
import 'video.js/dist/video-js.css';
Vue.prototype.video = videoJS;

// icon
// import '@/icons';

// messages
// import message from './message';
// Vue.prototype.tips = message;

// messages
// import messagebox from './message-box';
// Vue.prototype.tipbox = messagebox;
//Vue.use(VueCropper);
// import VueCropper from 'vue-cropper'; // 头像裁剪
// Vue.use(VueCropper);
